import React from 'react';
import { BackToTop } from '@/presentation/layouts/tools/back-to-top';
import { ContactUs } from '@/presentation/layouts/tools/contact-us';
import style from './index.module.scss';

export const Tools = () => <div className={style.toolsLayout}>
  <BackToTop />
  <ContactUs />
</div>;
